// extracted by mini-css-extract-plugin
export default {"root":"DepartmentStaffList_root__hFegC"};